<template>
    <div class="mask" v-show="show"></div>
    <CommonDialog class="save-dialog" v-show="show" :title="title" :show-close-button="false">
        <template v-slot:msg>
            <div class="prompt center">
                <span class="dialog-message">{{ message }}</span>
            </div>
        </template>
        <template v-slot:buttons>
            <div v-show="store.nowView == VIEW_TYPE.ANDROID || store.nowView == VIEW_TYPE.IOS"
                class="button-slot button-group">
                <div class="orange-btn save-dialog-txt dialog-btn" @click="handleBackToBookcase">{{ toBookcaseTxt }}</div>
                <div class="blue-btn save-dialog-txt dialog-btn" @click="handleExit">{{ exitTxt }}</div>
                <div class="blue-btn save-dialog-txt dialog-btn" @click="handleClose">{{ cancelTxt }}</div>
            </div>
        </template>
    </CommonDialog>
</template>

<script>
import CommonDialog from './Dialog.vue';
import SaveTool from '../../js/toolbar/save_tool';
import { store } from '../../store';
import { useUserStore } from '../../js/user_data';
import { API_GET_USER_RECORD } from '../../js/api';
import BookData from '../../js/book_data';
import AppRenderer from '@/js/app_renderer';
import { VIEW_TYPE } from '@/js/view_type';
export default {
    name: "SaveDialog",
    data: function () {
        return {
            show: false,
            title: "提示",
            message: "即將離開電子書，請問要",
            toBookcaseTxt: "回到書櫃",
            exitTxt: "離開電子書",
            cancelTxt: "取消",
            store,
            VIEW_TYPE,
            autoSave: true
        }
    },
    components: {
        CommonDialog
    },
    methods: {
        showDialog() {
            this.show = true;
        },
        handleClose() {
            this.show = false;
        },
        handleBackToBookcase() {
            console.log("handleBackToBookcase", this.autoSave)
            if (this.autoSave) this.handleAutoSave();
            AppRenderer.Instance.backToBookcase();
        },
        handleExit() {
            if (this.autoSave) this.handleAutoSave();
            AppRenderer.Instance.exit();
        },
        handleAutoSave() {
            console.log("handleAutoSave")
            SaveTool._instance.handleAutoSaveLocal();
        }
    }
}
</script>

<style scoped>
.save-dialog {
    z-index: var(--z-index-save-dialog);
}

.dialog-input {
    height: 1.5rem;
    width: calc(100% - 8rem);
    font-size: 1.2rem;
    margin-left: 0.5rem;
}

.dialog-input::placeholder {
    font-size: 1rem;
}

.button-slot {
    margin-bottom: 1rem;
}

.prompt {
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
}

.prompt.center {
    justify-content: center;
}

.dialog-warn {
    color: red;
}

.mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #30303080;
    z-index: var(--z-index-save-dialog);
}
</style>